module.exports = __webpack_public_path__ + "static/img/egg_b_12.07e853f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_12.png
// module id = I0s/
// module chunks = 1